export default __webpack_public_path__ + "static/media/Ae.fc9e63da.svg";